<template>
<div class="container box">
  <com-h1 title="议题提交"></com-h1>
  <div class="content2">
    <p><b>现在筹划中的专题公开征集演讲嘉宾，以下是征集形式与具体要求。</b></p>
    <div class="box-button apply">
      <a href="https://jinshuju.net/f/7wUiwn" target="_blank"><c-button>议题提交</c-button></a>
    </div>
    <h2>演讲议题形式</h2>
    <p><b>演讲时长</b></p>
    <ul>
      <li>45 分钟，包括提问环节</li>
    </ul>
    <p><b>演讲内容标准</b></p>
    <ul>
      <li>观点：申请人演讲的观点是否明确，所阐述的内容是否吸引人，是否有助于听众在知识和经验方面的积累？</li>
      <li>实践：ArchSummit 演讲内容，均以实践为出发。</li>
      <li>深度：演讲内容的深度将直接关系到听众的收获，听众能够从演讲中挖掘出的内容也是组委会看重的，原则上，有深度的演讲稿被采纳的机会更高。</li>
      <li>专业声誉：演讲人在所提交演讲涉及的专业领域的成就和从业经验也会作为评审的参考标准。</li>
      <li>不要广告：ArchSummit 讲台不是厂商宣传的舞台，请不要试图在演讲时做任何形式的广告。</li>
      <li>听众所得：听众在演讲分享中可能的收获是组委会最关注的，这也是 ArchSummit 大会举办的重要意义。</li>
    </ul>
    <!-- <h2>议题提交指南</h2>
    <p><b>请以文本形式按下述规定格式发送申请信息至<span><a href="Mailto:as_speakers@cn.infoq.com"> as_speakers@cn.infoq.com</a></span>，填写方式可参照本官网已上线的讲师信息；<br>另，请勿附带除演讲 Slides / 大头照以外的任何附件。</b></p>
    <ul>
      <li>姓名：</li>
      <li>手机：</li>
      <li>邮箱：</li>
      <li>微博/LinkedIn/微信个人或公众号：</li>
      <li>公司：</li>
      <li>部门：</li>
      <li>职位：</li>
      <li>所在城市：</li>
      <li>个人简介：（300 字左右）</li>
      <li>大头照：（肖像照不小于 400x500 像素，半身照不小于 800x1000 像素，尽量不要提供全身照）</li>
      <li>演讲经历：</li>
      <li>所属专题：</li>
      <li>演讲主题：（标注是否已分享过）</li>
      <li>主题摘要：（200-300字 介绍问题背景—解决方案选型—方案介绍—实施后效果说明）</li>
      <li>演讲提纲：</li>
      <li>听众受益：（列举几个收益）</li>
    </ul> -->

    <h2>演讲嘉宾福利</h2>
    <ul>
      <li>免费参加本届大会的所有分享（除闭门会议）</li>
      <li>优先享有和国际讲师单独沟通的机会或陪同</li>
      <li>外地讲师由组委会承担差旅</li>
      <li>可免费参与本届 ArchSummit 特别策划的演讲经验交流会与独享聚会</li>
      <li>组委会将会根据现场听众反馈对优秀讲师予以额外鼓励</li>
    </ul>

    <h2>注意事项</h2>
    <ul>
      <li>在大会议程尚未完全确定之前，可自由提交演讲议题</li>
      <li>若内容合适，但相应专题已无空档，可优先在下届 ArchSummit 获得演讲机会</li>
      <li>请确保您所提供的个人信息内容准确无误，一旦确认，信息将会刊登在大会官网并印制在会刊中</li>
      <li>请确保您在演讲内容中使用的案例已经获得第三方的认可和允许，我们将不负责由此引起的任何纠纷和问题</li>
      <li>确认的演讲内容将发布在主办单位的有关媒介中，包括会议演讲 PPT、现场视频等。此非强制条款，如果不同意，请提前声明</li>
      <li>对于已提交演讲议题的审批结果，我们将在大会开始前一个月通过电子邮件或电话联系的方式通知您</li>
      <li>演讲机会以 ArchSummit 组委会最终发送的演讲邀请函为准</li>
    </ul>
    <h2>推荐机制</h2>
    <ol>
      <li>如果在您心目中有非常合适的演讲人选，欢迎向组委会推荐（请在邮件中尽可能详述被推荐人的个人信息与可分享的话题信息，发送至<span><a href="Mailto:architect@geekbang.com"> architect@geekbang.com</a></span>）</li>
      <li>如果您想担任演讲嘉宾或者专题出品人，可以直接将您的大名/ID/微博等任何可联络信息发给我们，我们将即刻与您联系</li>
    </ol>

    <section class="partner" v-if="false">
      <div class="container">
        <p class="intro">本次大会紧扣当前热点，把握研发趋势，为参会者提供更多最具实践价值的精彩专题。</p>
        <h6 class="warn">目前还在筹划中的专题如下，欢迎提交议题：</h6>
        <a href='/'><p class="subheader">topic1</p></a>
        <p class="introduce">introduce1</p>
        <a href='/'><p class="subheader">topic2</p></a>
        <p class="introduce">introduce2</p>
        <h6 class="warn">以下专题内讲师已全部确认，不再接收新的议题：</h6>
        <a href="/"><p class="subheader">topic1</p></a>
        <p class="introduce">introduce1</p>
        <a href="/"><p class="subheader">topic2</p></a>
        <p class="introduce">introduce2</p>
      </div>
    </section>
  </div>
</div>
</template>

<script>
import ComH1 from 'gkConUI/com-h1'
import CButton from 'gkConUI/com-button'

export default {
  components: {
    ComH1,
    CButton
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
.apply
  margin: 30px 0
</style>
